<template>
  <v-autocomplete
    label="Client"
    v-model="model"
    :loading="loading"
    :items="options"
    :required="required"
    :rules="rules || []"
    :disabled="disabled"
    @input="handleInput"
    item-text="fullName"
    item-value="id"
    clearable
  >
    <template slot="item" slot-scope="{ item: client }">
      <v-list-tile-avatar>
        <img :src="client.avatar || '/img/missing/avatars/original.png'" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title> {{ client.fullName }} </v-list-tile-title>
        <v-list-tile-sub-title> {{ client.email }} </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>

    <template slot="selection" slot-scope="{ item: client }">
      <v-chip>
        <v-avatar>
          <img :src="client.avatar || '/img/missing/avatars/original.png'" />
        </v-avatar>
        {{ client.fullName }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapState } from 'vuex'

// Vue Component
export default {
  created() {
    this.$store.dispatch('admin/clients/fetchAll').then(() => (this.loading = false))
  },
  props: {
    value: { required: true },
    organization: { type: [Array, Object] },
    required: { type: Boolean, default: () => false },
    rules: { type: Array },
    disabled: Boolean,
    clearable: Boolean,
  },
  data() {
    return {
      loading: true,
      items: [],
      // Always store the ID in the model to avoid object/ID toggling
      model: this.normalizedValue(this.value),
    }
  },
  computed: {
    ...mapState('admin/clients', ['all']),

    clients() {
      if (this.all && this.all.length) return this.all
    },

    options() {
      if (!this.clients) return []

      const clients = JSON.parse(JSON.stringify(this.clients))
      if (!this.organization) return clients

      return this.clients.filter(c => c.organization.id === this.organization.id)
    },
  },

  watch: {
    value(newVal) {
      this.model = this.normalizedValue(newVal)
    },
  },

  methods: {
    normalizedValue(val) {
      if (val && typeof val === 'object') return val.id
      return val || null
    },
    handleInput(selected) {
      // Emit an ID consistently
      const id = this.normalizedValue(selected)
      this.$emit('input', id)
    },
  },
}
</script>
